import i18n from "../../../../../i18n";
import { FOURTH_FLOOR_HT_IMG } from "../../floor_images";
import elevator from "../../elevator_positions";

let fourth_floor_locations;
export default fourth_floor_locations = [
  // {
  //   floor: i18n.t("fourth_floor"),
  //   imageURL: FOURTH_FLOOR_HT_IMG,
  //   title: "401",
  //   marked_position_x: 41,
  //   marked_position_y: 197,
  // },
  // {
  //   floor: i18n.t("fourth_floor"),
  //   imageURL: FOURTH_FLOOR_HT_IMG,
  //   title: "413",
  //   marked_position_x: 72,
  //   marked_position_y: 192,
  // },
  // {
  //   floor: i18n.t("fourth_floor"),
  //   imageURL: FOURTH_FLOOR_HT_IMG,
  //   title: "414",
  //   marked_position_x: 110,
  //   marked_position_y: 181,
  // },
  // {
  //   floor: i18n.t("fourth_floor"),
  //   imageURL: FOURTH_FLOOR_HT_IMG,
  //   title: "415",
  //   marked_position_x: 155,
  //   marked_position_y: 133,
  // },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_HT_IMG,
    ...elevator.gym,
    title: "421",
    marked_position_x: 143,
    marked_position_y: 196,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_HT_IMG,
    ...elevator.gym,
    title: "422",
    marked_position_x: 235,
    marked_position_y: 100,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_HT_IMG,
    ...elevator.gym,
    title: "423",
    marked_position_x: 252,
    marked_position_y: 98,
  },
  // {
  //   floor: i18n.t("fourth_floor"),
  //   imageURL: FOURTH_FLOOR_HT_IMG,
  //   title: "424",
  //   marked_position_x: 147,
  //   marked_position_y: 173,
  // },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_HT_IMG,
    ...elevator.gym,
    title: "425",
    marked_position_x: 270,
    marked_position_y: 98,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_HT_IMG,
    ...elevator.gym,
    title: "426",
    marked_position_x: 291,
    marked_position_y: 98,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_HT_IMG,
    ...elevator.gym,
    title: "427",
    marked_position_x: 313,
    marked_position_y: 98,
  },
  {
    floor: i18n.t("fourth_floor"),
    imageURL: FOURTH_FLOOR_HT_IMG,
    ...elevator.gym,
    title: "428",
    marked_position_x: 304,
    marked_position_y: 127,
  },
];
